import React, {useEffect, useState} from "react";
import {ActivationType, validateToken} from "../../activation/activationApi";
import {globalMessageHandler, Spacer} from "../../../common";
import I18n from "i18n-js";
import {useNavigate, useParams} from "react-router-dom";
import Activation from "../../../components/Activation/Activation";
import {Alert, Box, CircularProgress, Typography} from "@mui/material";
import PageTransition from "../PageTransition";
import RegisterForm from "./stages/registerForm/registerForm";
import {registerActivation} from "./stages/registerForm/registerAPI";
import ActivationSuccess from "../../../components/Activation/ActivationSuccess";
import ActivationError from "../../../components/Activation/ActivationError";


export default function RegisterStages() {
  const [stage, setStage] = useState<string>('request');
  const [email, setEmail] = useState<string>('');
  const [token, setToken] = useState<string>('');
  const params = useParams();
  const navigate = useNavigate();

  function onSuccessRegister(email: string) {
    setEmail(email);
    setStage('activation');
  }

  async function onActivationSuccess(token: string) {
    setToken(token);
    setStage('loading');

    const response = await registerActivation(token);
    if (response.data.success) {
      setStage('success');
    } else {
      setStage('error');
    }
  }

  async function validateParamsToken() {
    setStage('loading');
    // @ts-ignore It's already validated at this point that params.token is not undefined
    const token: string = params.token;
    const response = await validateToken(token, ActivationType.REGISTRATION);
    const data = response.data;

    if (!data.success) {
      setStage('invalidToken');
    } else {
      onActivationSuccess(token);
    }
  }

  useEffect(() => {
    if (params.token !== undefined) {
      // Hide the default stage until token validation is done
      setStage('');

      validateParamsToken();
    }
  }, []);

  return (
    <>
      {
        stage === 'request'
          ? (
            <PageTransition direction={1}>
              <RegisterForm onSuccessRegister={onSuccessRegister}/>
            </PageTransition>
          )
          : ''
      }
      {
        stage === 'activation'
          ? (

            <PageTransition direction={1}>
              <Activation
                onActivationSuccess={onActivationSuccess}
                type={ActivationType.REGISTRATION}
                email={email}
                message={
                  <>
                    <Spacer h={1}/>
                    <Alert severity="info">
                      <Typography variant="body1" sx={{fontWeight: "bold"}}>
                        {I18n.t("Register.activation.title")}
                      </Typography>
                      <Typography variant="body1">
                        {I18n.t("Register.activation.description")} <br/>
                        {I18n.t("Register.activation.description2")}
                      </Typography>
                    </Alert>
                    <Spacer h={1}/>
                  </>
                }/>
            </PageTransition>
          )
          : ''
      }
      {
        stage === "success"
          ? (
            <PageTransition direction={1}>
              <ActivationSuccess messageCategory="Register.registerSuccess" />
            </PageTransition>
          )
          : ''
      }
      {
        stage === "error"
          ? (
            <PageTransition direction={1}>
              <ActivationError messageCategory="Register.registerError" />
            </PageTransition>
          )
          : ''
      }
      {
        stage === "invalidToken"
          ? (
            <PageTransition direction={1}>
              <ActivationError
                messageCategory={"Activation.invalidTokenPage"}
                onlyContent={false}
              />
            </PageTransition>
          )
          : ''
      }
      {
        stage === 'loading'
          ? (
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              <CircularProgress/>
            </Box>
          )
          : ''
      }
    </>
  );
}